import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { zodValidator } from '@tanstack/zod-adapter';

import { ErrorInvitation, MateVerify } from '../../components/mate-invitation';

const searchParamsSchema = z
  .object({
    email: z.string().optional(),
    token: z.string().optional(),
    companyId: z.string().optional(),
    subscriptionId: z.string().optional(),
  })
  .catchall(z.unknown());

export const Route = createFileRoute('/m/mate-verify')({
  validateSearch: zodValidator(searchParamsSchema),
  component: MateVerifyRoute,
});

function MateVerifyRoute() {
  const search = Route.useSearch();

  // Use window.location.search directly to get raw URL params
  // TanStack Router's searchStr has already been processed and may have
  // converted numeric strings to numbers, losing precision for large integers
  const searchParams = new URLSearchParams(
    typeof window !== 'undefined' ? window.location.search : ''
  );

  const email = search.email;

  // Extract these values directly from URL to avoid TanStack Router's automatic
  // number coercion which loses precision for large integers (> Number.MAX_SAFE_INTEGER)
  // or incorrectly converts numeric-looking strings to numbers
  const userid = searchParams.get('userid') || undefined;
  const token = search.token;
  const firstname = searchParams.get('firstname') || undefined;
  const lastname = searchParams.get('lastname') || undefined;
  const phonenumber = searchParams.get('phonenumber') || undefined;
  const companyId = search.companyId;
  const subscriptionId = search.subscriptionId;

  if (!email || !userid || !token || !companyId || !subscriptionId) {
    return <ErrorInvitation />;
  }

  return (
    <MateVerify
      {...{
        email,
        userid,
        token,
        firstname,
        lastname,
        phonenumber,
        companyId,
        subscriptionId,
      }}
    />
  );
}
